import React, { useRef } from 'react';
import VirtualWindow from './VirtualWindow';
import { TVirtualWindowData, TWindowPosition, TWindowSize } from '../../types';
import './VirtualWindowsContainer.css';

interface VirtualWindowsContainerProps {
  windows: TVirtualWindowData[];
  onClose: (windowId: string) => void;
  onMinimize: (windowId: string) => void;
  onMaximize: (windowId: string) => void;
  onBringToFront: (windowId: string) => void;
  onUpdatePosition: (windowId: string, position: TWindowPosition) => void;
  onUpdateSize: (windowId: string, size: TWindowSize) => void;
}

const VirtualWindowsContainer: React.FC<VirtualWindowsContainerProps> = ({
  windows,
  onClose,
  onMinimize,
  onMaximize,
  onBringToFront,
  onUpdatePosition,
  onUpdateSize,
}) => {

  const mainContentRef = useRef<HTMLDivElement>(null);

  const handleWindowFocus = (windowId: string) => {
    onBringToFront(windowId);
  };

  return (
    <div id="virtual-windows-container" className="virtual-windows-container" ref={mainContentRef}>
      {windows.map((window) => (
        <VirtualWindow
          key={window.id}
          window={window}
          onClose={onClose}
          onMinimize={onMinimize}
          onMaximize={onMaximize}
          onBringToFront={handleWindowFocus}
          onUpdatePosition={onUpdatePosition}
          onUpdateSize={onUpdateSize}
          containerRef={mainContentRef}
        />
      ))}
    </div>
  );
};

export default VirtualWindowsContainer;
